<template>
<section class="w1312 main-content-wrap">
  <section class="notice-box">
    <div class="notice-container">
      <div class="bread-crumb">
        <a href="javascript:;" @click="goBack()" class="c-666" mars_sead="vschool_shouyepeizhi_noticelanding_buttonclick" :data-vis-mvar="JSON.stringify({'sessionTarget': sessionTarget})">返回</a>
        &gt;
        正文内容
      </div>
      <div class="notice-wrap">
        <div class="notice-title">
          {{noticeInfo.title}}
          <a href="javascript:;" class="download" title="下载" v-if="noticeInfo.attachment && noticeInfo.attachment.url" @click="download(noticeInfo.attachment && noticeInfo.attachment.url)">
            <i class="down-icon"></i>
            附件: {{noticeInfo.attachment && noticeInfo.attachment.filename}}
          </a>
        </div>
        <div class="notice-content" v-html="noticeInfo.text"></div>
      </div>
    </div>
  </section>
</section>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  name: '',
  data () {
    return {

    }
  },
  computed: {
    ...mapState(['sessionTarget', 'noticeInfo', 'queryUserPromise'])
  },
  mounted () {
    this.queryUserPromise.then(() => {
      const {
        id
      } = this.$route.params
      if (!id) {
        return this.$message.warning('链接违法，请检查')
      }
      this.queryNoticeDetail(id)
    })
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    download (url) {
      if (!url) {
        return this.$message.warning('下载链接异常，请联系管理员')
      }
      let $a = document.createElement('a');
        $a.setAttribute('href', url);
        // $a.setAttribute('download', `${this.title}-${this.moment(this.operationTimestamp)}.jpeg`);
        let fileLink = document.createElement('span')
        fileLink.setAttribute('style', 'cursor: pointer; -webkit-tap-highlight-color: transparent')
        $a.appendChild(fileLink)
        let body = document.getElementsByTagName('body')[0]
        body.appendChild($a)
        fileLink.click()
        body.removeChild($a)
    },
    ...mapActions(['queryNoticeDetail'])
  }
}
</script>

<style lang="scss" scoped>
.notice-box {
  background: url(../../assets/img/bg-notice2.png) no-repeat top center;
  background-size: 100%;
  margin-top: -40px;
}
.notice-container {
  background: url(../../assets/img/notice_info_bg.png) no-repeat top center;
  background-size: 100% 98px;
  border-radius: 8px;
  position: relative;
  z-index: 1;
  margin-bottom: 25px;
  overflow: hidden;
  .bread-crumb {
    font-size: 16px;
    color: #999;
    padding: 23px 36px;
  }
  .notice-wrap {
    background: #fff;
    padding: 0 36px;
    margin-top: 23px;
  }
  .notice-title {
    font-size: 24px;
    color: #333;
    font-weight: bold;
    text-align: center;
    padding: 35px 0 70px;
    .download {
      float: right;
      font-size: 14px;
      color: #666;
    }
  }
  .notice-content {
    font-size: 16px;
    line-height: 30px;
    padding: 0 36px 138px;
  }
}
.down-icon {
  display: inline-block;
  width: 14px;
  height: 14px;
  background: url(../../assets/img/bg-down.png) no-repeat;
  background-size: 14px;
  font-weight: 400!important;
}
</style>
